import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import Verify from "./components/Auth/Verify";
import Dashboard from "./components/Dashboard";
import Header from "./components/Header";
import SearchLease from "./components/SearchLease";
import LeaseExtensionForm from "./components/Calculator/LeaseExtensionForm";
import LeaseExtensionResults from "./components/Calculator/LeaseExtensionResults";
import CallbackSent from "./components/Calculator/CallbackSent";
import jwtDecode from "./modules/jwtDecode";
import { initGA, trackPageView } from "./modules/analytics";
import "./App.css";

initGA();

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);
  return null;
}

function App() {
  const [isLoggedIn, setLoggedIn] = useState(false);
  let userRole;

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      jwtDecode(storedToken)
        .then((result) => {
          if (!result.success) {
            setLoggedIn(false);
          } else {
            setLoggedIn(true);
          }
        })
        .catch(() => setLoggedIn(false));
    }
  }, []);

  const handleLogin = () => {
    setLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setLoggedIn(false);
  };

  return (
    <div className="App">
      <Router>
        <PageTracker />
        <Header isLoggedIn={isLoggedIn} onLogout={handleLogout} />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<SearchLease />} />
          <Route path="/calculator" element={<LeaseExtensionForm />} />
          <Route path="/calculator/results" element={<LeaseExtensionResults />} />
          <Route path="/calculator/callback-sent" element={<CallbackSent />} />

          {/* Auth routes */}
          <Route
            path="/login"
            element={
              isLoggedIn ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />
            }
          />
          <Route path="/register" element={<Register />} />
          <Route path="/verify/:username" element={<Verify />} />

          {/* Protected dashboard for admin/mgmt */}
          <Route
            path="/dashboard/*"
            element={
              isLoggedIn ? (
                <Dashboard userRole={userRole} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
